<script setup>
import { onMounted, ref } from 'vue'
import { useCharityStore } from '@/stores/charity'
import { storeToRefs } from 'pinia'

const charityStore = useCharityStore()

const { getCharityInfo } = storeToRefs(charityStore)

const website = ref(null)
const show = ref(false)
const myIframe = ref(false)

const widgetScriptUrl =
  import.meta.env.VITE_HARNESS_WIDGET_URL || 'https://widget.harnessapp.com/harness-widget-v2.js'

const onSubmit = () => {
  show.value = true
}

const onReset = () => {
  show.value = false
  website.value = null
}

onMounted(() => {
  !(function (t, e) {
    var a = document.head,
      n = document.createElement('script')
    ;(n.type = 'text/javascript'),
      (n.src = widgetScriptUrl),
      (n.onreadystatechange = e),
      (n.onload = e),
      a.appendChild(n)
  })(0, function () {
    window.HarnessWidget.init({
      charity_id: getCharityInfo.value.charity_id
    })
  })
})
</script>

<template>
  <span
    v-if="website && show"
    role="button"
    style="opacity: 0.8"
    class="avatar avatar-xs avatar-primary avatar-circle position-absolute"
    @click.prevent="onReset"
  >
    <span class="avatar-initials">
      <i class="far fa-times"></i>
    </span>
  </span>
  <iframe
    v-if="website && show"
    ref="myIframe"
    class="site-iframe"
    :src="website"
    style="height: 100%"
  >
  </iframe>
  <main v-else id="content" role="main">
    <div class="container pt-4">
      <form class="row g-3" @submit.prevent="onSubmit">
        <div class="col">
          <input
            v-model="website"
            type="url"
            name="website"
            placeholder="https://website.com"
            required="required"
            class="form-control"
          />
        </div>
        <div class="col">
          <button class="btn btn-primary full-width" type="submit">Preview</button>
        </div>
      </form>
    </div>
  </main>
</template>
